module.exports = __webpack_public_path__ + "static/img/618cea1e16b539075.6fe853f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/618cea1e16b539075.webp
// module id = 1030
// module chunks = 0